var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('NavbarTop'),_c('HomeSection'),_c('AmenitiesSection'),_c('GallerySection'),_c('ContactSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }